import { StoplightProject } from "@stoplight/elements-dev-portal";
import "@stoplight/elements-dev-portal/styles.min.css";
import "./Bookvariaveis.css"

function Bookvariaveis() {
  return (
    <div className="container">
      <StoplightProject projectId="cHJqOjI4MzAzOA" router="hash" />
    </div>
  );
}

export default Bookvariaveis;
